import { Modal } from "@mecha/design-components/dist/src/components/Elements/Modal";
import ApiKeyAdded from "./ApiKeyAdded";
import Logger from "../../../../libs/Logger";
import { useStore } from "../../../../storeManager/stores";
import ConfigureKeyModal from "./ConfigureKeyModal";
import { ApiKeyModalSteps } from "../../../../config/constants";
import { observer } from "mobx-react";

const GenerateKeyModal = () => {
  const log = new Logger({ module: "Settings", component: "EnterInformation" });
  const { setApiKeyModal, setGenerateKeyModalStep, generateKeyModalStep } =
    useStore().settingsStore;

  const modalContentJSX = {
    [ApiKeyModalSteps.STEP1]: <ConfigureKeyModal />,
    [ApiKeyModalSteps.STEP2]: <ApiKeyAdded />,
  };
  const modalTitleJSX = {
    [ApiKeyModalSteps.STEP1]: (
      <p className="text-mob-h6 md:text-web-h6 font-medium text-light-n-400 dark:text-dark-n-400">
        New API key
      </p>
    ),
    [ApiKeyModalSteps.STEP2]: (
      <p className="text-mob-h6 md:text-web-h6 font-medium text-light-n-400 dark:text-dark-n-400">
        Generate API key
      </p>
    ),
  };

  const handleModalClose = () => {
    setApiKeyModal(false);
    setGenerateKeyModalStep(ApiKeyModalSteps.STEP1);
  };

  return (
    <Modal
      opened
      padding="0"
      radius="md"
      overlayColor="bg-black dark:bg-dark"
      overlayClass="z-999"
      className="z-999"
      closeOnOverlayClick={false}
      hideCloseButton
      contentClassName="p-4 lg:p-8 md:w-[518px] xs:w-[335px] border-2 border-light-400 dark:border-dark-400 max-w-xl dark:bg-dark-800 bg-light-800 flex flex-col justify-between mecha-scroll-1"
      titleClassName="flex w-full s font-bold justify-between items-center"
      title={
        <div className="flex flex-row justify-between items-center w-full">
          <p className="dark:text-white">
            {modalTitleJSX[generateKeyModalStep] ?? ""}
          </p>
        </div>
      }
      onClose={handleModalClose}
    >
      {modalContentJSX[generateKeyModalStep] ?? ""}
    </Modal>
  );
};

export default observer(GenerateKeyModal);
